import { is } from '@js/utils/type'
import { resolveElements } from '@js/utils/elements'

const defaultOptions = {
	root: null,
	rootMargin: "0px",
	amount: 0,
	once: false,
}

const thresholds = {
	any: 0,
	all: 1,
}

const useInView = (elementOrSelector, onStart, userOptions) => {
	// If IntersectionObserver is not supported, bail
	if (typeof IntersectionObserver === "undefined") {
		return () => {}
	}

	const options = {
		...defaultOptions,
		...userOptions,
	}

	const elements = resolveElements(elementOrSelector)

	const activeIntersections = new WeakMap()

	const onIntersectChange = (entries) => {
		entries.forEach((entry) => {
			const onEnd = activeIntersections.get(entry.target)

			/**
			 * If there's no change to the intersection, we don't need to
			 * do anything here.
			 */
			//if (entry.isIntersecting === Boolean(onEnd)) return

			if (entry.isIntersecting) {
				entry.target.dataset.inView = 'entered'
				const newOnEnd = onStart(entry)
				if (is.function(newOnEnd)) {
					activeIntersections.set(entry.target, newOnEnd)
				}

				if (options.once) {
					observer.unobserve(entry.target)
				}
			} else if (!entry.isIntersecting){
				entry.target.dataset.inView = 'exited'
				onEnd && onEnd(entry)
				activeIntersections.delete(entry.target)
			}
		})
	}

	const { root, rootMargin, amount } = options
	const observer = new IntersectionObserver(onIntersectChange, {
		root,
		rootMargin,
		threshold: typeof amount === "number" ? amount : thresholds[amount],
	})

	elements.forEach((element) => {
		observer.observe(element)
		element.setAttribute('use-in-view', 'loaded')
	})

	return () => observer.disconnect()
}

export { useInView }
